Close
<script setup lang="ts">
import { BannerInterface } from '@/api/banner';
import CONSTANTS from '@/helpers/constants';
import { useBannersStore } from '@/stores/banners';
import Close from '~icons/svg/close';

const props = defineProps<BannerInterface>();
const bannersStore = useBannersStore();
const hasError = ref(false);
const imgRef = ref<HTMLImageElement | null>(null);
const hasLink = !!props.link_url;

const isSmallScreen = useMediaQuery(`(max-width: ${CONSTANTS.BREAKPOINTS.SM}px)`);

const closeBanner = () => {
  bannersStore.hide();
  bannerHeightHandler(0);
};

const bannerClickHandler = () => {
  if (props.link_url) {
    window.open(props.link_url, props.link_new_tab ? '_blank' : '_self');
  }
};

function bannerHeightHandler(imgHeight: number) {
  document.documentElement.style.setProperty('--banner-height', `${imgHeight}px`);
}

function onLoad() {
  const imgHeight = imgRef.value ? imgRef.value.clientHeight : 0;
  bannerHeightHandler(imgHeight);
}

watch(
  () => [props.image_mobile, props.image_desktop],
  () => {
    hasError.value = false;
  },
);
</script>

<template>
  <div :class="[classes.bannerWrapper]">
    <div :class="classes.banner" @click="bannerClickHandler">
      <img
        ref="imgRef"
        :src="isSmallScreen ? props.image_mobile : props.image_desktop"
        :class="[classes.banner, hasError ? classes.error : undefined, hasLink ? classes.clickable : undefined]"
        @error="hasError = true"
        @load="onLoad"
      />

      <button
        v-if="props.closable && !hasError"
        :class="classes.closeButton"
        @click="
          (e) => {
            e.stopPropagation();
            closeBanner();
          }
        "
      >
        <Close />
      </button>
    </div>
  </div>
</template>

<style lang="scss" module="classes" src="./Banner.scss" />
